import {LocaleKey} from "./Locale";

export const LocaleRU: LocaleKey = {
    trailerVittaLucis: 'https://vkvideo.ru/video-218216146_456239285',
    trailerIkeNorris: 'https://vkvideo.ru/video-218216146_456239058',
    about: 'Я очень сильно люблю видеоигры, рассказываю о своих проектах, делюсь своим опытом и процессом разработки.',
    soundtrack: 'Саундтрек',
    pressKit: 'Пресс-кит',
    gameVittaLucis: 'Витта Люцис - наёмница из частной церковной гильдии, обладающая демонической силой. Соберите отряд из Церковных Демонов и отправляйтесь в приключенческий экшен в духе дарк фэнтези. Отчасти вера в бога оказалась ошибкой - проклятья, демоны и прочая нечисть существуют.',
    gameIkeNorris: 'Айк Норрис - хороший мальчик и очень дружелюбный пёс, а также член моей семьи! Как не сложно догадаться, сюжет игры будет связан именно с ним. Всех карт раскрывать не буду, моя игра об этом расскажет. Пролог уже доступен!',
    socialNetworksTitle: 'Соцсети',
    socialNetworksDescription: 'Все свежие новости',
    contactsTitle: 'Контакты',
    contactsDescription: 'Сергей Исаев',
    yandexMail: 'Яндекс Почта',
    otherTitle: 'Разное',
    otherDescription: 'Официальные страницы в интернете',
    yandexMusic: 'Яндекс Музыка',
    vkMusic: 'VK Музыка',
    zvuk: 'Звук',
    mtsMusic: 'МТС Музыка',
    supportTitle: 'Поддержать',
    supportDescription: 'Разработка видеоигр',
    yandexTips: 'Яндекс Чаевые',
    inactiveTitle: 'Неактивно',
    inactiveDescription: 'Тоже официальные страницы',
    dzen: 'Дзен',
    platform: 'Платформа',
    trashTitle: 'Корзина',
    trashDescription: 'Площадка повесила теневой бан, полностью заблокировала или больше не существует',
    pikabu: 'Пикабу'
}
